import {
	Directive,
	EventEmitter,
	HostBinding,
	HostListener,
	Input,
	Output
} from '@angular/core';

@Directive( {
	selector: '[appDragDropFiles]'
} )
export class DragDropFilesDirective {

	@HostBinding( 'class.dragOver' ) private dragOver = false;

	@HostBinding( 'class.dragLeave' ) private dragLeave = false;

	@HostBinding( 'class.drop' ) private drop = false;

	@Input() private fileInput: HTMLInputElement;

	@Output() fileDropped = new EventEmitter<File[]>();

	@Input() acceptedFileTypes: string[];

	@Input() allowMultiFileDrop = true;

	constructor() { }

	// Dragover listener
	@HostListener( 'dragover', [ '$event' ] ) onDragOver( evt ) {
		evt.preventDefault();
		evt.stopPropagation();
		this.dragOver = true;
		this.dragLeave = false;
	}

	// Dragleave listener
	@HostListener( 'dragleave', [ '$event' ] )
	public onDragLeave( evt ) {
		evt.preventDefault();
		evt.stopPropagation();
		this.dragOver = false;
		this.dragLeave = true;
	}

	// Drop listener
	@HostListener( 'drop', [ '$event' ] )
	public ondrop( evt ) {
		evt.preventDefault();
		evt.stopPropagation();
		this.drop = true;

		const files = Array.from( evt.dataTransfer.files );
		const filteredFiles: File[] = [];

		files.forEach( ( file: File ) => {
			if ( !this.allowMultiFileDrop && filteredFiles.length === 0 || this.allowMultiFileDrop ) {
				const extension = '.' + file.name.split( '.' ).pop().split( '/' ).pop().toLowerCase();
				if (
					this.acceptedFileTypes && this.acceptedFileTypes.includes( extension )
				) {
					filteredFiles.push( file );
				} else if ( !this.acceptedFileTypes ) {
					filteredFiles.push( file );
				}
			}
		} );

		this.fileDropped.emit( filteredFiles );
	}
}
